import { approveImportResponseSchema, importJobResponseSchema, importJobsResponseSchema, importTextRequestSchema, importUrlRequestSchema, updateImportRequestSchema, } from '@fewerbags/schema';
const job = { parse: importJobResponseSchema };
/** /api/v1/imports — URL / pasted-text recipe import with a human review step (D15). */
export function createImportsApi(http, base) {
    return {
        /** Server-side fetch with SSRF guards; a failed fetch still returns a job carrying `error`. */
        fromUrl: async (input) => http.post(`${base}/url`, importUrlRequestSchema.parse(input), job),
        fromText: async (input) => http.post(`${base}/text`, importTextRequestSchema.parse(input), job),
        /**
         * Photo of a recipe card → draft. The server cleans the image and sends it to
         * its AI provider; only offered when `auth.config()` reports `features.photoImport`.
         */
        fromPhoto: async (file) => {
            const form = new FormData();
            form.append('file', file, file instanceof File ? file.name : 'recipe.jpg');
            return http.postForm(`${base}/photo`, form, job);
        },
        /** The 50 most recent jobs for this household, newest first. */
        list: async () => http.get(base, { parse: importJobsResponseSchema }),
        get: async (id) => http.get(`${base}/${encodeURIComponent(id)}`, job),
        /** Save reviewer edits to the draft (only while the job is still pending). */
        update: async (id, input) => http.patch(`${base}/${encodeURIComponent(id)}`, updateImportRequestSchema.parse(input), job),
        /** Turn the reviewed draft into a recipe; returns the job and the new recipe id. */
        approve: async (id) => http.post(`${base}/${encodeURIComponent(id)}/approve`, undefined, {
            parse: approveImportResponseSchema,
        }),
        reject: async (id) => http.post(`${base}/${encodeURIComponent(id)}/reject`, undefined, job),
        remove: async (id) => http.del(`${base}/${encodeURIComponent(id)}`),
    };
}
//# sourceMappingURL=imports.js.map